/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const HealthCheckStatus1 = {
  Healthy: "healthy",
} as const;
export type HealthCheckStatus1 = ClosedEnum<typeof HealthCheckStatus1>;

export const HealthCheckStatus2 = {
  Healthy: "healthy",
} as const;
export type HealthCheckStatus2 = ClosedEnum<typeof HealthCheckStatus2>;

export type Workers = {
  status: HealthCheckStatus2;
};

/**
 * Service is healthy - all workers are operational.
 */
export type HealthCheckResponse = {
  status: HealthCheckStatus1;
  /**
   * When this health check was performed
   */
  timestamp: Date;
  workers: { [k: string]: Workers };
};

/** @internal */
export const HealthCheckStatus1$inboundSchema: z.ZodNativeEnum<
  typeof HealthCheckStatus1
> = z.nativeEnum(HealthCheckStatus1);
/** @internal */
export const HealthCheckStatus1$outboundSchema: z.ZodNativeEnum<
  typeof HealthCheckStatus1
> = HealthCheckStatus1$inboundSchema;

/** @internal */
export const HealthCheckStatus2$inboundSchema: z.ZodNativeEnum<
  typeof HealthCheckStatus2
> = z.nativeEnum(HealthCheckStatus2);
/** @internal */
export const HealthCheckStatus2$outboundSchema: z.ZodNativeEnum<
  typeof HealthCheckStatus2
> = HealthCheckStatus2$inboundSchema;

/** @internal */
export const Workers$inboundSchema: z.ZodType<Workers, z.ZodTypeDef, unknown> =
  z.object({
    status: HealthCheckStatus2$inboundSchema,
  });
/** @internal */
export type Workers$Outbound = {
  status: string;
};

/** @internal */
export const Workers$outboundSchema: z.ZodType<
  Workers$Outbound,
  z.ZodTypeDef,
  Workers
> = z.object({
  status: HealthCheckStatus2$outboundSchema,
});

export function workersToJSON(workers: Workers): string {
  return JSON.stringify(Workers$outboundSchema.parse(workers));
}
export function workersFromJSON(
  jsonString: string,
): SafeParseResult<Workers, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Workers$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Workers' from JSON`,
  );
}

/** @internal */
export const HealthCheckResponse$inboundSchema: z.ZodType<
  HealthCheckResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  status: HealthCheckStatus1$inboundSchema,
  timestamp: z.string().datetime({ offset: true }).transform(v => new Date(v)),
  workers: z.record(z.lazy(() => Workers$inboundSchema)),
});
/** @internal */
export type HealthCheckResponse$Outbound = {
  status: string;
  timestamp: string;
  workers: { [k: string]: Workers$Outbound };
};

/** @internal */
export const HealthCheckResponse$outboundSchema: z.ZodType<
  HealthCheckResponse$Outbound,
  z.ZodTypeDef,
  HealthCheckResponse
> = z.object({
  status: HealthCheckStatus1$outboundSchema,
  timestamp: z.date().transform(v => v.toISOString()),
  workers: z.record(z.lazy(() => Workers$outboundSchema)),
});

export function healthCheckResponseToJSON(
  healthCheckResponse: HealthCheckResponse,
): string {
  return JSON.stringify(
    HealthCheckResponse$outboundSchema.parse(healthCheckResponse),
  );
}
export function healthCheckResponseFromJSON(
  jsonString: string,
): SafeParseResult<HealthCheckResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => HealthCheckResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'HealthCheckResponse' from JSON`,
  );
}
